type Props = {
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
};

const SaleIcon = ({
  fill = 'none',
  stroke = '#8907E7',
  width = 17,
  height = 16
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5656 2.11353C8.78146 1.89767 9.08738 1.79781 9.38902 1.84473L13.3999 2.46864C13.8113 2.53263 14.134 2.8554 14.198 3.2668L14.8219 7.27765C14.8689 7.5793 14.769 7.88522 14.5531 8.10108L8.76772 13.8865C8.39415 14.2601 7.78849 14.2601 7.41493 13.8865L2.78017 9.25175C2.40661 8.87818 2.40661 8.27252 2.78017 7.89896L8.5656 2.11353Z"
        stroke={stroke}
        strokeLinejoin="round"
      />
      <circle
        r="1"
        transform="matrix(0.707107 0.707106 -0.707107 0.707106 10.6666 6.08087)"
        stroke={stroke}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SaleIcon;
